export default __webpack_public_path__ + "static/media/heroImage.14137b93.png";